import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/check",
    name: "Check",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Check.vue")
  },
  {
    path: "/save",
    name: "Save",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "save" */ "../views/Save.vue")
  },
  {
    path: "/login",
    name: "Login",
    props: true,
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue")
  },
  {
    path: "/logout",
    name: "Logout",
    props: true,
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Logout.vue")
  },
  {
    path: "/finish",
    name: "Finish",
    component: () =>
      import(/* webpackChunkName: "finish" */ "../views/Finish.vue")
  },
  {
    path: "/history",
    name: "History",
    component: () =>
      import(/* webpackChunkName: "finish" */ "../views/History.vue")
  },
  {
    path: "/instructions",
    name: "Instructions",
    component: () =>
      import(/* webpackChunkName: "finish" */ "../views/Instructions.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 100);
    });
  }
});

export default router;
